"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var auth_1 = require("../auth");
var Home = function (props) {
    var _a = react_1.useState(''), userName = _a[0], setUserName = _a[1];
    react_1.useEffect(function () {
        console.log('useEffect is called for username ', userName);
    }, [userName]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null,
            "Welcome1 ",
            userName),
        react_1.default.createElement("p", { onClick: function () {
                auth_1.InfoAuth.signOut()
                    .then(function () {
                    props.history.push('/auth');
                })
                    .catch(function () { return console.log('error signing out...'); });
            } }, "Sign Out")));
};
exports.default = Home;
//# sourceMappingURL=Home.js.map